import * as React from "react";

interface Props extends React.SVGProps<SVGSVGElement> {
    size?: number;
}

const PersonAddIcon = ({ size = 18, ...props }: Props) => (
    <svg
        width={size}
        height={size}
        viewBox="0 0 17 13"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            d="M10.8182 0C9.99842 0 9.21224 0.34241 8.63258 0.951903C8.05292 1.5614 7.72727 2.38805 7.72727 3.25C7.72727 4.11195 8.05292 4.9386 8.63258 5.5481C9.21224 6.15759 9.99842 6.5 10.8182 6.5C11.6379 6.5 12.4241 6.15759 13.0038 5.5481C13.5834 4.9386 13.9091 4.11195 13.9091 3.25C13.9091 2.38805 13.5834 1.5614 13.0038 0.951903C12.4241 0.34241 11.6379 0 10.8182 0ZM10.8182 1.54375C11.0313 1.54375 11.2423 1.58788 11.4392 1.67363C11.6361 1.75938 11.8149 1.88506 11.9656 2.0435C12.1163 2.20194 12.2358 2.39003 12.3174 2.59705C12.3989 2.80406 12.4409 3.02593 12.4409 3.25C12.4409 3.47407 12.3989 3.69594 12.3174 3.90295C12.2358 4.10997 12.1163 4.29806 11.9656 4.4565C11.8149 4.61494 11.6361 4.74062 11.4392 4.82637C11.2423 4.91212 11.0313 4.95625 10.8182 4.95625C10.6051 4.95625 10.3941 4.91212 10.1972 4.82637C10.0003 4.74062 9.82142 4.61494 9.67074 4.4565C9.52006 4.29806 9.40053 4.10997 9.31898 3.90295C9.23743 3.69594 9.19545 3.47407 9.19545 3.25C9.19545 2.79747 9.36642 2.36348 9.67074 2.0435C9.97506 1.72352 10.3878 1.54375 10.8182 1.54375ZM2.31818 2.4375V4.875H0V6.5H2.31818V8.9375H3.86364V6.5H6.18182V4.875H3.86364V2.4375H2.31818ZM10.8182 7.3125C8.755 7.3125 4.63636 8.39312 4.63636 10.5625V13H17V10.5625C17 8.39312 12.8814 7.3125 10.8182 7.3125ZM10.8182 8.85625C13.1132 8.85625 15.5318 10.0425 15.5318 10.5625V11.4563H6.10455V10.5625C6.10455 10.0425 8.5 8.85625 10.8182 8.85625Z"
            fill={props.color || "currentColor"}
        />
    </svg>
);
export default PersonAddIcon;
